<template>
  <div :class="{ 'invalid': isInvalid }">
    <multiselect v-model="value"
                 :options="values"
                 :track-by="track"
                 :label="track"
                 :searchable="true"
                 :multiple="multiple"
                 select-label=""
                 :showNoResults="false"
                 :placeholder="placeholder"
                 tagPosition="bottom"
                 :limit="limit"
                 :loading="isLoading"
                 selectedLabel="Sélectionné"
                 deselectLabel=""
                 @select="onSelect"
                 @close="onTouch"
                 @search-change="asyncQuery"
                 @open="open"
                 @input="onChange">
        <template slot="beforeList" v-if="multiple && options.length > 0">
                <div class="text-center" v-if="value.length != options.length" @click="selectAll" style="margin-top:5px; cursor:pointer;">
                    <span class="option__title">Tout sélectionner</span><hr>
                </div>
                <div class="text-center" v-if="value.length === options.length" @click="deselectAll"
                    style="margin-top:5px; cursor:pointer;">
                    <span class="option__title">Tout désélectionner</span>
                    <hr>
                </div>
            </template>
            <template slot="tag" slot-scope="props">
                <span class="multiselect__tag" :style="{ backgroundColor: props.option.color, color: props.option.text }">
                    {{ props.option[track] }}
                    <i aria-hidden="true" tabindex="1" @click="props.remove(props.option)"
                        class="multiselect__tag-icon"></i>
                </span>
            </template>
            <template slot="noOptions">
                Aucun résultat.
            </template>
        </multiselect>
        <span class="invalid-feedback" v-show="isInvalid">Le champs est requis</span>
    </div>
</template>

<script>
import Multiselect from 'vue-multiselect'

/*
    @prop options : Tableau de valeur à afficher
    @prop track : Libellé à affichier dans le select
    @prop multiple : Permet de sélectionner une ou plusieurs valeurs dans le select
    @prop required : Si le champs est requis
    @prop editable : Mode édition ou non
    @prop id : Id du champs hidden (ex : users/skills/capacitations...)
    @prop typeAjax : Indique si oui ou non on souhaite utiliser de l'ajax
    @prop filter : Indique si le champs fait partie d'un filtre sur les listes
*/

export default {
    components: { Multiselect },
    props: {
        options: Array,
        track: String,
        placeholder: String,
        multiple: Boolean,
        required: Boolean,
        editable: Boolean,
        route: String,
        limit: Number,
        id: String,
        typeAjax: Boolean,
        filter: Boolean,
    },
    data() {
        return {
            value: this.multiple ? [] : null,
            values: this.options,
            invalid: false,
            isTouched: false,
            input: this.id,
            element: null,
            edit: this.editable,
            url: this.route,
            isLoading: false,
            attribute: this.track,
            ajaxable: this.typeAjax,
            canFilter: this.filter
        }
    },
    computed: {
        isInvalid() {
            return this.required && this.isTouched && this.value.length === 0;
        }
    },
    methods: {
        onChange(option) {
            if (this.multiple)
                this.syncValue();
            else
                this.element.setAttribute('value', option.id);
        },
        onSelect(option) {
            // TODO
        },
        async onTouch() {
            this.isTouched = true;
        },
        async open() {
            if (this.typeAjax) {
                await this.asyncQuery('');
            }
        },
        selectAll() {
            this.value = this.options;
            this.syncValue();
        },
        syncValue() {
            if (this.value && this.value.length > 0) {
                let tempValues = this.canFilter ? this.value.map(function (v) {
                    return v.id
                }).join(';') : this.value.map(function (v) {
                    return v.id
                }).join(',');
                this.element.setAttribute('value', tempValues);
            } else {
                this.element.setAttribute('value', []);
            }
        },
        deselectAll() {
            this.value = [];
            this.element.value = this.value;
        },
        async asyncQuery(query) {
            if (this.url) {
                this.isLoading = true;
                const API = $('meta[name="api-token"]').attr('content');
                await fetch(this.url + '?q=' + encodeURIComponent(query), {
                    method: 'GET',
                    credentials: 'same-origin',
                    headers: {
                        "Content-Type": "application/json",
                        "X-Requested-With": "XMLHttpRequest",
                        'Accept': 'application/json',
                        'Authorization': `Bearer ${API}`,
                    }
                }).then((response) => {
                    return response.json();
                }).then((data) => {
                    // Les endpoints renvoient une liste, ou { data: liste } pour les ressources Laravel.
                    this.values = Array.isArray(data) ? data : (data.data || []);
                }).catch(error => {
                    this.values = [];
                });
                this.isLoading = false;
            }
        },
        async getDataByIds(values) {
            console.log(values);
            const API = $('meta[name="api-token"]').attr('content');
            await fetch(this.url + '?' + this.element.getAttribute('name') + '=' + encodeURIComponent(values), {
                method: 'GET',
                credentials: 'same-origin',
                headers: {
                    "Content-Type": "application/json",
                    "X-Requested-With": "XMLHttpRequest",
                    'Accept': 'application/json',
                    'Authorization': `Bearer ${API}`,
                }
            }).then((response) => {
                return response.json();
            }).then((data) => {
                this.value = Array.isArray(data) ? data : (data.data || []);
                this.syncValue();
            }).catch(error => {
                this.value = [];
            });
        },
        setValueAttribute(s) {
            let tempArray = this.element.value.split(s);
            this.values.forEach(option => {
                tempArray.forEach(value => {
                    if (String(option.id) === String(value)) {
                        this.value.push(option);
                    }
                })
            })
        }
    },
    mounted() {
        this.element = document.getElementById(this.input + "-input-target");
        this.element.value = this.element.value.length > 0 ? this.element.value : [];
        if (this.typeAjax && this.element.value.length > 0) {
            if (this.element.value.includes(';')) {

                this.element.value = this.element.value.replace(/;/g, ",");
            }
            this.getDataByIds(this.element.value);
        }
        if (!this.typeAjax && !this.canFilter && (this.edit || this.element.value.length > 0)) {
            if (this.element.value.includes(';')) {
                this.element.value = this.element.value.replace(/;/g, ",");
            }
            this.setValueAttribute(',');
        }

        if (!this.typeAjax && this.canFilter) {
            this.setValueAttribute(';');
        }

    },

}
</script>
